<template>
  <div class="app-main-content" style="position:relative;">
    <booking-tree-grid
      v-show="view==='list'"
      ref="bookingTreeGrid"
      :context="context"
      :is-query="isQuery"
      :is-fba="isFba"
      @look="lookHandle"
      @edit="editHandle"
      @add="addHandle"
      @split="splitHandle"
      @copy="copyHandle"
    />
    <booking-workspace
      v-show="view==='detail'"
      ref="bookingWorkspace"
      :parent-context="context"
      :is-fba="isFba"
      :view="view"
      @copy="copyHandle"
      @add="addHandle"
      @back="backToList"
      @synchronizeRowData="synchronizeRowData"
      @reloadJob="reloadJob"
    />
    <!--业务复制选择复制哪些信息-->
    <job-copy-window
      v-show="copyDialog.visible"
      ref="jobCopyWindow"
      :visible.sync="copyDialog.visible"
      :lob="copyDialog.job.lob || ''"
      :is-master="copyDialog.job.masterFlag"
      @confirmCallBack="confirmCallBackHandler"
    />

    <job-no-rule-selector
      v-show="jobNoRule.visible"
      ref="jobCopyWindow"
      :visible.sync="jobNoRule.visible"
      :rules="jobNoRule.rules || []"
      @selectedBack="doCopyJob"
    />
  </div>
</template>

<script>
import { BookingNewContext } from './bookingNewContext'
import jobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import jobNoRuleSelector from '@/components/Cargo/Job/jobNoRuleSelector'
import bookingTreeGrid from './components/AeBooking/bookingTreeGrid'
import bookingWorkspace from './components/AeBooking/bookingWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import SeaImContainerTypeDialog from '@/components/Cargo/Job/seaImContainerTypeDialog'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { advancedQuery, doCopyJob } from '@/api/AirExport/airExportJob'
import { queryJobNoRule } from '@/api/seaExport/seaExportJob'
import { getLoading } from '@/utils/utilBaseElement'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { JumpUtil } from '@/utils/JumpUtil'

export default {
  name: 'AeBooking',
  components: { SeaImContainerTypeDialog, bookingTreeGrid, bookingWorkspace, jobCopyWindow, jobNoRuleSelector },
  data() {
    return {
      loading: null,
      context: BookingNewContext.getInstance(),
      view: 'list',
      isFba: false,
      copyDialog: {
        visible: false,
        job: {}
      },
      jobNoRule: {
        visible: false,
        rules: ''
      },
      jobNewDialog: {
        visible: false,
        rules: '',
        showRule: false
      },
      isQuery: false // 根据路由参数进行高级查询
    }
  },
  computed: {
    office() {
      return this.context.office
    }
  }, /*
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 如果此处需要用到生命周期created内初始化的数据，可能会导致报错
      if (to.query.jobNo) {
        vm.toDetail(vm, to.query.jobNo)
      } else if (Object.keys(to.params).length > 0) {
        const params = to.params
        if (params.view) {
          vm.view = params.view
        }
        if (params.action) {
          vm.action = params.action
        }
        if (params.jobNo) {
          vm.$nextTick(async() => {
            await vm.$refs.bookingTreeGrid.toSimpleQuery(params.jobNo, true)
            if (vm.view === 'detail') {
              const rowData = vm.$refs.bookingTreeGrid.rowData
              vm.$refs.bookingWorkspace.onShow(vm.action, rowData, rowData.find(p => p.jobNo === params.jobNo))
            }
          })
        }
      }
    })
  },*/
  mounted() {
    if (this.$route.params.code) {
      this.isQuery = true
      this.view = 'list'
      this.sopNodeAdvancedQuery()
    }
    // 判断是否FBA
    const index = this.$route.path.lastIndexOf('/')
    const str = this.$route.path.substr(index + 1)
    this.isFba = str ? str.startsWith('FBA') : false
  },
  activated() {
    const params = this.$route.params
    if (params.conditions) {
      this.isQuery = true
      this.view = 'list'
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(params.conditions)
      delete params.conditions
    } else if (this.$route.params.jobNos) {
      const filter = {
        fba: this.isFba
      }
      JumpUtil.jumpToTab(advancedQuery, filter, this.$route.params, this)
    } else if (this.$route.params.jobUuid) {
      const params = this.$route.params
      this.toDetailByUuid(params.jobUuid, params.activeTabName)
      delete params.jobUuid
      delete params.activeTabName
    } else if (this.$route.params.jobNo) {
      this.toDetail(this, this.$route.params.jobNo)
      delete this.$route.params.jobNo
    } else if (this.$route.query.jobNo) {
      this.toDetail(this, this.$route.query.jobNo, this.$route.params.branchId)
      location.replace(location.href.replace(location.hash, `#${this.$route.path}`))
    }
    if (this.$route.params.code) {
      if (this.$route.meta.showExtraParam) {
        this.view = 'list'
        this.$route.meta.showExtraParam = false
      }
      this.sopNodeAdvancedQuery()
    }
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    this.context.loading = false
    return true
  },
  methods: {
    // 首页sop面板高级查询
    sopNodeAdvancedQuery() {
      const { code, subCode, name, subName, newSubNodes, etdStart, templateKey } = this.$route.params
      let jobState = this.$route.params.jobState
      jobState = jobState.split(',').map(item => { return Number(item) })
      const data = [
        {
          fieldName: 'trackingInfo._multipleState_',
          fieldType: 'trackingMultiple',
          operator: '=',
          value: {
            operator: 'and',
            value: [
              {
                code,
                name,
                details: []
              }
            ]
          }
        },
        {
          fieldName: 'job.ETD',
          fieldType: 'FIELD_DATE_RANGE',
          operator: 'RANGE',
          value: `type=date,start=${etdStart}`
        },
        {
          fieldName: 'job.JOB_STATE',
          fieldType: null,
          label: '',
          operator: 'IN',
          value: jobState
        },
        { fieldType: 'FIELD_CHECKBOX', fieldName: 'loadRelationJobs', operator: '=', value: false }
      ]
      if (subCode && subName) {
        data[0].value.value[0]['details'].push({ code: subCode, name: subName })
      } else {
        data[0].value.value[0]['details'] = newSubNodes
      }
      // Sop模板UUID
      if (templateKey) {
        data.push(
          {
            fieldName: 'job.TRACKING_TEMPLATE_UUID',
            fieldType: null,
            label: '',
            operator: '=',
            value: templateKey
          }
        )
      }
      this.$refs.bookingTreeGrid.isAdvancedQuery = true
      this.$refs.bookingTreeGrid.toAdvancedQuery(data)
    },
    // 查询job后跳转详情
    toDetail(vm, jobNo, branchId) {
      const params = {}
      params.branchId = branchId || vm.$store.getters.currentOfficeId
      params.jobNo = jobNo
      params.pageNum = 1
      vm.view = 'detail'
      advancedQuery(params).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          vm.$refs.bookingWorkspace.saveJobNos = []
          vm.$refs.bookingWorkspace.removedJobNos = []
          const index = rowData.findIndex(p => p.jobNo === jobNo)
          if (index > 0) {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            vm.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          vm.$message.error(vm.$t('Message.NoRecordMeetTheConditions'))
          vm.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        vm.$message.error(vm.$t('Message.JumpFailed'))
      })
    },
    // 查询job后跳转详情（通过uuid）
    toDetailByUuid(jobUuid, activeTabName) {
      this.view = 'detail'
      advancedQuery({ jobUuid, branchId: this.$store.getters.currentOfficeId, pageNum: 1 }).then(res => {
        const rowData = res.data.list
        if (rowData && rowData.length > 0) {
          this.$refs.bookingWorkspace.saveJobNos = []
          this.$refs.bookingWorkspace.removedJobNos = []
          const index = rowData.findIndex(p => p.jobUuid === jobUuid)
          this.$refs.bookingWorkspace.activeTabName = activeTabName || ''
          if (index > 0) {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[index])
          } else {
            this.$refs.bookingWorkspace.onShow('look', rowData, rowData[0])
          }
        } else {
          this.$message.error(this.$t('Message.NoRecordMeetTheConditions'))
          this.$refs.bookingWorkspace.goBack()
        }
      }).catch(() => {
        this.$message.error(this.$t('Message.JumpFailed'))
      })
    },
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    editHandle(row) {
      this.detailHandle('edit', row)
    },
    async addHandle(row) {
      if (JobUtils.checkHQ()) { return }
      if (this.isFba) {
        row.fba = true
      }
      if (this.context.config.get('UseNewJobNoRule').toString() === '1') {
        this.jobNoRule.job = row
        await this.confirmCallBackHandler('add')
      } else {
        await this.context.prepareData()
        this.detailHandle('add', row)
      }
    },
    // 新增job 选择类型完成以后得事件
    async addHandlerSelect(data) {
      const _job = new AirExportJob().fillDefaultValue().getData()

      //  callFun
      _job.jobNoRule = data['jobNoRule']
      _job.containerLoadType = data.cargoType
      _job.masterFlag = _job.containerLoadType === 'CON'
      _job.lob = 'AE'
      // bookingWorkspace onShow 已实现 this.loadEntityDefaultValues()
      // 新增集拼，默认显示MBL页签
      if (_job.masterFlag) {
        _job.signHBL = false
      } else {
        _job.signHBL = true
      }
      _job.csr = this.$store.getters.userId
      // h5 不需要updatePageJobData(_job,true,false);

      this.detailHandle('add', _job)
    },
    splitHandle(row) {
      this.detailHandle('split', row)
    },
    backToList(saveJobNos, removedJobNos) {
      if (this.$route.query.jobNo) {
        delete this.$route.query.jobNo
        delete this.$route.query.currentOfficeId
      }
      this.view = 'list'
      if (saveJobNos && saveJobNos.length > 0 || removedJobNos && removedJobNos.length > 0) {
        this.$refs.bookingTreeGrid.toQuery(saveJobNos, removedJobNos)
      }
    },
    copyHandle(row) {
      // 以后按本次选择复制，不弹出此框
      if (!row) return
      if (JobUtils.checkHQ()) { return }
      this.copyDialog.job = row
      if (this.copyDialog.job.masterFlag) {
        const isMasterShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob + '_MASTER')
        if (isMasterShowView !== true) {
          this.copyDialog.visible = true
        } else {
          this.confirmCallBackHandler('copy')
        }
        return
      }
      const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_' + row.lob) // 是否显示复制选项弹框【勾选是true不显示】
      this.$logger.log('是否显示复制选项弹框', typeof isShowView + isShowView)
      if (isShowView !== true) {
        this.copyDialog.visible = true
      } else {
        this.confirmCallBackHandler('copy')
      }
    },
    async confirmCallBackHandler(type = 'copy') {
      await this.context.prepareData()
      if (String(this.context.config.get('UseNewJobNoRule')) === '1') {
        this.jobNoRule.type = type
        this.loading = getLoading()
        this.context.loading = true
        queryJobNoRule(SystemConstants.AE.code).then(res => {
          this.ruleResultHandler(res)
        }).finally(() => {
          this.context.loading = false
          this.loading.close()
        })
      } else {
        this.doCopyJob()
      }
    },
    ruleResultHandler(event) {
      const rules = event.data
      if (rules && rules.length > 1) {
        this.jobNoRule.visible = true
        this.jobNoRule.rules = rules
      } else if (rules && rules.length > 0) {
        const rule = rules[0]
        this.doCopyJob(rule)
      } else {
        this.$message.warning(this.$t('SeaExport.MaintainJobNoRule'))
        return
      }
    },
    doCopyJob(rule) {
      const jobNoRule = !rule ? '' : rule.uuid
      if (this.jobNoRule.type === 'add') {
        this.jobNoRule.job.jobNoRule = jobNoRule
        this.detailHandle('add', this.jobNoRule.job)
        return
      }
      const item = {}
      item.jobRule = jobNoRule
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      const lob = this.copyDialog.job.lob
      // 复制哪些页签的数据
      let notMatchAgainSelect = false
      if (this.copyDialog.job.masterFlag) {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob + '_MASTER')
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob + '_MASTER')
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob + '_MASTER')
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob + '_MASTER')
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob + '_MASTER')
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob + '_MASTER')
      } else {
        item.vesselEq = LocalStorageUtils.getConfiguration('COPY_VESSEL_EQ_' + lob)
        item.mbl = LocalStorageUtils.getConfiguration('COPY_MBL_' + lob)
        item.hbl = LocalStorageUtils.getConfiguration('COPY_HBL_' + lob)
        item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_' + lob)
        item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUT' + lob)
        notMatchAgainSelect = LocalStorageUtilsNew.getConfiguration('NOT_MATCH_AGAIN_SELECT_' + lob)
      }
      item.source = 'aeBooking'
      this.loading = getLoading()
      this.context.loading = true
      item.masterFlag = this.copyDialog.job.masterFlag
      doCopyJob(item).then(async res => {
        this.context.loading = false
        this.loading.close()
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId || newJob.opOffice
        await this.context.prepareData()
        // CARGO-18534 ID：5616 冠业 空运出口-订单预审希望新版本你能够参考老版本复制
        newJob.chargeWeight = 0
        newJob.quantityBooking = 0
        newJob.weightBooking = 0
        newJob.cubageBooking = 0
        newJob.chargeWeightBooking = 0
        newJob.quantityActual = 0
        newJob.weightActual = 0
        newJob.cubageActual = 0
        newJob.cWeight = 0
        newJob.chargeWeightImperial = 0
        newJob.weightBookingImperial = 0
        newJob.cubAgeBookingImperial = 0
        newJob.chargeWeightBookingImperial = 0
        newJob.weightActualImperial = 0
        newJob.cubAgeActualImperial = 0
        newJob.cWeightImperial = 0
        // 复制的时候，后端没有返回airCargoDoc，只返回了cargoDoc
        if (!newJob.airCargoDoc && newJob.cargoDoc) {
          newJob.airCargoDoc = newJob.cargoDoc
        }
        const continueExec = await JobUtils.validateJobFieldActive(newJob, this, 'AeBooking')
        if (!continueExec) {
          return
        }
        await JobUtils.doNotMatchAgainSelect(newJob, notMatchAgainSelect)
        this.detailHandle('copy', newJob)
      })
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.bookingWorkspace.rowData
      } else {
        this.view = 'detail'
        // rowData = this.$refs.bookingTreeGrid.rowData
        // rowData = this.$refs.bookingTreeGrid.gridOptions.api.forEachNode().rowsToDisplay.map(node => node.data)
        rowData = []
        this.$refs.bookingTreeGrid.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
          if (node.data) {
            rowData.push(node.data)
          }
        })
      }
      this.$refs.bookingWorkspace.saveJobNos = []
      this.$refs.bookingWorkspace.removedJobNos = []
      this.$refs.bookingWorkspace.onShow(type, rowData, row)
    },
    synchronizeRowData(rowData) {
      this.$refs.bookingTreeGrid.rowData = rowData
    },
    // 重新加载Job
    reloadJob(job) {
      this.detailHandle('look', job)
    }
  }
}
</script>
<style lang="scss">
</style>
